// extracted by mini-css-extract-plugin
module.exports = {"productToast":"ProductToast_product-toast__QIKM4","productToastLink":"ProductToast_product-toast-link__XFtMs"};